// extracted by mini-css-extract-plugin
export default {"heading":"LandingSection_heading__4Srt-","subheading":"LandingSection_subheading__3o42S","container":"LandingSection_container__vSQaq","item":"LandingSection_item__rgwGJ"};